<template>
  <div class="main-login container-fluid min-vh-100 overflow-auto px-3 px-md-0 backdrop-blur bg-md-white d-flex flex-column flex-md-row">

    <!-- فرم ورود -->
    <div class="col-12 col-md-8 text-center d-flex justify-content-center align-items-center position-relative">
      <div class="box-login-wrapper mx-auto mt-5 mt-md-0" style="max-width: 490px; width: 100%; z-index: 1;">
        <div class="box-login p-3 py-5 px-4 px-md-5">
          <h2 class="w-100 d-none d-md-block fs-6 mb-4 text-center text-primary-custom">
            درگاه ورود
          </h2>
          <div v-if="showErr" class="alert alert-danger" role="alert">
            {{ errMsg }}
          </div>
          <div v-if="isBanned" class="alert alert-danger" role="alert">
            {{ banMessage }}
          </div>
          <form @submit.prevent="login">
            <!-- نام کاربری -->
            <div class="mb-3 input-group-custom">
              <label class="form-label text-black text-right w-100 mb-2" for="user-name">
                نام کاربری
              </label>
              <input
                  maxlength="11"
                  inputmode="numeric"
                  @input="form.userName = $event.target.value.replace(/\D/g, '').slice(0, 11)"
                  v-model="form.userName"
                  type="text"
                  id="user-name"
                  class="form-control form-control-lg rounded-3 bg-white text-right"
                  :disabled="isBanned"
              />
              <div class="error-div"></div>
            </div>

            <!-- رمز ورود -->
            <div class="mb-3 input-group-custom">
              <label for="password" class="form-label text-black text-right w-100 mb-2">
                رمز ورود
              </label>
              <div class="position-relative">
                <input
                    maxlength="50"
                    v-model="form.password"
                    :type="showPass ? 'text' : 'password'"
                    id="password"
                    :disabled="isBanned"
                    class="form-control form-control-lg rounded-3 bg-white text-right ps-5"
                />
                <button
                    @click="showPass = !showPass"
                    type="button"
                    class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0"
                    style="left: 12px; z-index: 5;"
                >
                  <img v-if="!showPass" src="@/assets/images/icons/eye-close.svg" alt="eye" width="20" height="20">
                  <img v-else src="@/assets/images/icons/eye-open.svg" alt="eye" width="20" height="20">
                </button>
              </div>
            </div>

            <!-- کپچا -->
            <div class="captcha-box">
              <label v-if="captchaImg" class="form-label text-black text-right w-100 mb-2">
                کد امنیتی
              </label>
              <div v-if="captchaImg" class="row g-2 align-items-center">
                <div class="col-12 col-md-6 order-2 order-md-1">
                  <input
                      maxlength="4"
                      v-model="form.captcha"
                      placeholder="کد امنیتی را وارد کنید"
                      class="form-control form-control-lg rounded-3 bg-white text-end"
                      type="text"
                  >
                </div>
                <div class="col-12 col-md-6 order-1 order-md-2">
                  <div class="captcha-img d-flex align-items-center justify-content-between h-100 px-2 py-1 bg-opacity-25 bg-md-white rounded-3">
                    <img
                        v-if="captchaImg"
                        class="img-fluid"
                        style="max-width: 130px; max-height: 50px;"
                        :src="captchaImg"
                        alt="captcha"
                    >
                    <button
                        type="button"
                        @click="getCaptcha"
                        :disabled="loadingCaptcha"
                        class="btn btn-primary text-white btn-sm rounded d-flex align-items-center justify-content-center"
                        style="width: 35px; height: 33px;"
                    >
                      <i class="fa fa-refresh" :class="{'spin-animation': loadingCaptcha}"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- دکمه ورود -->
              <div class="w-100 mt-4">
                <button
                    type="submit"
                    :disabled="loading || !captchaImg"
                    class="btn btn-primary text-white w-100 rounded-3 d-flex align-items-center justify-content-center"
                    style="height: 44px;"
                >
                  <svg
                      v-if="loading"
                      aria-hidden="true"
                      role="status"
                      class="me-2 spinner-border spinner-border-sm text-white"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                  >
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                  </svg>
                  {{ loading ? 'در حال ورود ...' : 'ورود' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="left-blur-icon col-12 col-md-4 d-flex justify-content-center align-items-center overflow-auto backdrop-blur bg-white/30 border-end border-white">
      <div class="text-center">
        <img src="@/assets/images/hadaf-logo.png" alt="logo" class="img-fluid mb-2">
        <span class="d-block">سیستم پاسخگویی به شهروندان</span>
      </div>
    </div>

    <v-snackbar
        v-model="snackbar"
        :timeout="2000"
        :color="snackbarColor"
        rounded="pill"
        vertical
    >
      <div class="text-subtitle-1 pb-2 w-100 text-end"></div>
      <p class="w-100 text-end">{{ snackbarText }}</p>
    </v-snackbar>
  </div>
</template>

<script setup>
import {ref, reactive, watch, computed} from 'vue'
import axios from "axios";

import { useUserStore } from "@/store/user.js";
import { useStore } from "vuex";
import {useRouter} from "vue-router";

const apiBaseUrl = window.appConfig.API_URL_BASE
const captchaImg = ref('')
const errors = ref([])
const loading = ref(false)
const snackbar = ref(false)
const loadingCaptcha = ref(false)
const showPass = ref(false)
const snackbarColor = ref('#ff0000')
const snackbarText = ref('')
const showErr = ref(false)
const errMsg = ref('')

const form = reactive({
  userName: '',
  password: '',
  captcha: '',
})

watch(
    () => form.userName,
    (newVal) => {
      if (newVal.length === 11) {
        getCaptcha()
      }
    }
)
const showCaptcha = ref(true)
const userStore = useUserStore()
const isBanned = computed(() => userStore.ban)
const banMessage = computed(() => userStore.banMsg)
const getCaptcha = () => {
  if (form.userName.length !== 11) {
    showMsg('ابتدا نام کاربری خود را به درستی وارد کنید', '#f00')
    return
  }
  loadingCaptcha.value = true
  form.captcha = ''
  axios.post(apiBaseUrl + 'api/captcha', { username: form.userName })
      .then(res => {
        captchaImg.value = res.data.captcha_image
        loadingCaptcha.value = false
      }).catch(err => {
    if (err?.response?.status === 403) {
      errMsg.value = err.response.data.message
      showErr.value = true
      showCaptcha.value = false
    }
  })
}

const store = useStore()
const showMsg = (text, color) => {
  store.dispatch('snackbar/show', { text, color })
}

const login = () => {
  if (form.password === '' || form.captcha === '' || form.userName === '') {
    showMsg('لطفا موارد را به درستی وارد کنید!', '#ff0000')
    return
  }
  loading.value = true
  const body = {
    username: form.userName,
    password: form.password,
    captcha: form.captcha.toLowerCase(),
  }
  axios.post(apiBaseUrl + 'api/login', body)
      .then(res => {
        let token = res.data.access_token
        setToken(token)
        getUserData(token)
      }).catch(err => {
    loading.value = false
    getCaptcha()
    const status = err?.response?.status
    errors.value = err?.response?.data?.errors
    const msg = err?.response?.data.message
    if (status === 401 || status === 403) {
      showMsg(msg, '#ff0000')
      return;
    }
    if (status === 422) {
      showMsg(msg, '#ff0000')
      if (err?.response?.data?.password_must_change) {
        this.$router.push('/auth/choice-password')
      }
      return;
    }

    if (!err?.response) {
      showMsg('اینترنت خود را بررسی کرده و مجدد  تلاش کنید!', '#ff0000')
      return
    }
    showMsg('مشکلی پیش آمده. لطفا چند دقیقه بعد تلاش کنید!', '#ff0000')
  })
}
const router = useRouter()
const  getUserData =async(token)=> {
  const userStore = useUserStore()

  try {
    await userStore.loadUser(token)
    loading.value = false

    const userStr = userStore.userInfo
    let data = userStr
    const permissionsSystem = data?.data?.permissions.some(item => item.category === "system")
    if (data.data.main_user === 1 || permissionsSystem) {

      router.push('/')
    } else {
      router.push('/management/dashboard')
    }
  }catch (err){
    loading.value = false
    if (err?.response?.status === 422 && err?.response?.data?.password_must_change) {
      router.push({name:'newPassword'})
      return
    }
  }finally {
    loading.value = false
  }
}
const setToken = (token) => {

  localStorage.setItem('token',token)
}

</script>

<style scoped lang="scss">

.main-login {
  background: center/cover no-repeat url("../../../assets/images/bg-login.jpg");
  backdrop-filter: blur(8px);
}

@media (min-width: 768px) {
  .main-login {
    backdrop-filter: none;
  }
}
.bg-white\/30{
background: rgba(255, 255, 255, 0.3);
}
.box-login {
  width: 100%;
  max-width: 490px;
  border-radius: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.12);
  background: #f5f4f4;

  h2.text-primary-custom {
    color: #1696DF !important;
  }
}

.captcha-img {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.12);
  min-height: 44px;
}
input{
  font-size: 14px;
}
.input-group-custom {
  .form-control {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.12);
    height: 44px;
    color: #222;
  }
}

.left-blur-icon {
  backdrop-filter: blur(8px);
}

@media (max-width: 767.98px) {
  .left-blur-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    align-items: flex-start;
    padding-top: 1rem;

    > div {
      color: #fff;

      img {
        margin: 0 auto;
        display: block;
      }
    }
  }

  .box-login {
    width: 100%;
    height: auto;
  }

  .main-login {
    padding-top: 120px; /* فاصله برای لوگو در موبایل */
  }
}

/* انیمیشن اسپین برای آیکون رفرش کپچا */
.spin-animation {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* برای اطمینان از نمایش درست در RTL */
.form-control {
  direction: rtl;
}
</style>
